
import Swal from "sweetalert2/dist/sweetalert2.js";
import store from '@/store';
import router from '@/router';
import { Actions } from '@/store/enums/StoreEnums';
export default class Messages {
	static showError = (errors) => {
        
        const safeErrors = errors || { Error: ["Request failed."] };
        const errorsArray = Object.keys(safeErrors).map(function (key, index) {
            const value = safeErrors[key];
            if (Array.isArray(value)) {
                return value.join(",");
            }
            if (value === null || value === undefined) {
                return "";
            }
            if (typeof value === "string") {
                return value;
            }
            try {
                return JSON.stringify(value);
            } catch {
                return String(value);
            }
        }).filter(Boolean).join('<br>')
        Swal.fire({
            html: '<span>'+errorsArray+'</span>',
            icon: "error",
            buttonsStyling: true,
            showCancelButton: false,
            showConfirmButton: true,
            reverseButtons: true,
            customClass: {
                confirmButton: "btn btn-primary",
            },
        }).then(function () {
            store.dispatch(Actions.SET_ERROR,{})
        });

	};
    static showSuccess = (message,redirect="") => {
        
        Swal.fire({
            html: '<span>'+message+'</span>',
            icon: "success",
            buttonsStyling: true,
            showCancelButton: false,
            showConfirmButton: true,
            reverseButtons: true,
            customClass: {
                confirmButton: "btn btn-primary",
            },
        }).then(function () {
            store.dispatch(Actions.SET_SUCCESSFULLY_SUBMITTED,false)
            if(redirect != ""){
                router.push({ name: redirect });
            }
        });

	};
    
}
